'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var V2Service = function V2Service($cookieStore, $rootScope) {

    var redirectToV2 = function redirectToV2(roleId) {
        $rootScope.globals.currentUser.roleId = roleId;
        var stringCookie = 'globals=' + JSON.stringify($rootScope.globals) + '; path=/' + V2CONTEXT + '/;';
        // Delete V2 cookie by setting the expiry date in the past
        var d = new Date();
        d.setTime(d.getTime() - 1);
        var expires = 'expires=' + d.toUTCString() + ';';
        document.cookie = stringCookie + expires;

        // $cookieStore.put('globals', $rootScope.globals);
        // Update v2 cookie with updated token
        document.cookie = stringCookie;
        window.location = window.location.origin + '/' + V2CONTEXT + '/index.html';
    };

    return { redirectToV2: redirectToV2 };
};

exports.default = V2Service;


// WEBPACK FOOTER //
// ./client/app/common/services/v2.service.js